import React, { StrictMode, useEffect, useMemo } from "react";
import "./App.scss";
import { Calendar, View, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "../node_modules/react-big-calendar/lib/css/react-big-calendar.css";
import {
  BigCalendarEvent,
  GoogleCalendarImporter,
  GoogleCalendarFeed,
} from "./GoogleCalendarImporter";
import { SchoolSelector } from "./SchoolSelector";
import { CALENDARS } from "./CALENDARS";
import { TooltipOnHoverEventWrapper } from "./Popover";

const localizer = momentLocalizer(moment);

export interface HFCSCalendarProps {
  events: BigCalendarEvent[];
  onViewChanged: (view: View) => void;
  view: View;
}

class HFCSCalendar extends React.Component<HFCSCalendarProps, any> {
  setView(view: View) {
    this.props.onViewChanged(view);
  }

  public render() {
    return (
      <Calendar
        localizer={localizer}
        events={this.props.events}
        min={moment().startOf("day").add(7, "hours").toDate()}
        max={moment().endOf("day").subtract(2, "hours").toDate()}
        defaultView={this.props.view}
        view={this.props.view}
        onView={(view: View) => this.setView(view)}
        titleAccessor={(e: BigCalendarEvent) => e.title}
        messages={{
          next: "Next ›",
          previous: "‹ Previous",
        }}
        components={{
          eventWrapper: TooltipOnHoverEventWrapper,
        }}
        eventPropGetter={(e: BigCalendarEvent) => ({
          className: `calendar-item calendar-item-${e.resource.id}`,
        })}
      />
    );
  }
}

interface IHookAppProps {
  feed?: string;
}

const HookApp: React.FunctionComponent<IHookAppProps> = (props) => {
  const [loading, setLoading] = React.useState(true);
  const [events, setEvents] = React.useState<BigCalendarEvent[]>([]);
  const [view, setView] = React.useState<View>("week");
  const [selected, setSelected] = React.useState<GoogleCalendarFeed[]>([]);
  const importer = useMemo(
    () => new GoogleCalendarImporter("AIzaSyBidfnQVzSwa1549oZxkm9KmT4bdui5oes"),
    []
  );

  useEffect(() => {
    if (props.feed) {
      const feed = CALENDARS.find((x) => x.slug === props.feed);
      if (feed) setSelected([CALENDARS[0], feed]);
      else setSelected([CALENDARS[0]]);
    }
  }, [props.feed]);

  useEffect(() => {
    setLoading(true);
    const feeds = selected.map((f) =>
      importer.getCalendar(f, [
        `timeMin=${moment().subtract(3, "month").toISOString()}`,
      ])
    );
    const performFetch = async () => {
      const done = await Promise.all(feeds);
      const merged = ([] as BigCalendarEvent[]).concat.apply(
        [],
        done
      ) as BigCalendarEvent[];
      setEvents(merged);
      setLoading(false);
    };

    performFetch();
  }, [selected, importer]);

  return (
    <StrictMode>
      <div className="HFCS-Calendar-App" id="calendar-app">
        {loading && <div className="hfcs-loading"></div>}
        {!loading && (
          <>
            <SchoolSelector
              selected={selected}
              onUpdate={(selected) => setSelected(selected)}
            />
            <HFCSCalendar
              events={events}
              onViewChanged={(view) => setView(view)}
              view={view}
            />
          </>
        )}
      </div>
    </StrictMode>
  );
};

export default HookApp;
